import React, { Fragment, Component } from 'react';

import { withStyles } from '@mui/styles';

import { TextField, Autocomplete, ButtonBase, FormControlLabel, Radio, RadioGroup } from '@mui/material';

import { TYPES_WITHOUT_BOUNDS } from '../RestrictionsPage';

import Node from '../../../common/Node';
import Search from '../../../common/Search';
import Macros from '../../../common/Macros';
import Switcher from '../../../common/Switcher';
import LoaderNew from '../../../common/LoaderNew';
import CommonStyles from '../../../common/CommonStyles';
import ArrowTooltipCss from '../../../common/ArrowTooltipCss';
import TrplSelect from '../../../common/TrplControls/TrplSelect';
import TrplCheckbox from '../../../common/TrplControls/TrplCheckbox';

import Edit from '@mui/icons-material/Edit';
import AutorenewOutlined from '@mui/icons-material/AutorenewOutlined';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';

import ValueApplyDialog from './ValueApplyDialog';
import { isEqual } from '../../../utils/lodash';

const styles = {
  rstBlock: {
    '&:hover': {
      boxShadow: '1px 3px 6px rgba(0, 0, 0, 0.2)',
    },
  },
  rstRow: {
    display: 'flex',
    padding: '5px 10px',
    position: 'relative',
    background: '#FDFDFD',
    boxSizing: 'border-box',
    '& .rst-edit-icon': {
      display: 'flex',
    },
  },
  rstRowOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 3,
  },
  rstSaveEdit: {
    right: '10px',
    bottom: '5px',
    position: 'inherit',
  },
  rstInput: {
    zIndex: '4',
    maxHeight: '20px',
    minHeight: '20px',
    fontSize: 12,
    border: 'none',
    color: '#4E4C4C',
  },
  rstCheckbox: {
    padding: '0px',
    height: '16px',
    '& .MuiSvgIcon-root': {
      fontSize: '16px',
    },
  },
  rstCheckboxGray: {
    padding: '0px',
    height: '16px',
    '& .MuiSvgIcon-root': {
      color: '#4c4c4c',
      fontSize: '16px',
    },
  },
  rstCheckboxLabel: {
    color: '#4E4C4C',
    fontSize: 11,
    marginRight: '10px',
  },
  tooltip: {
    background: 'rgba(78, 76, 76, 0.5)',
    fontSize: '12px',
    color: '#fff',
  },
  overrideBtn: {
    zIndex: '4',
    color: '#fff',
    fontSize: '10px',
    marginTop: '10px',
    padding: '1px 12px',
    borderRadius: '10px',
    background: '#222029',
    opacity: '0.9',
    boxShadow: '0px 1px 0px rgba(103, 94, 120, 0.1), inset 0px 1px 0px rgba(255, 255, 255, 0.5)',
    '&:hover': {
      opacity: '1',
      cursor: 'pointer',
      background: '#222029',
    },
  },
  deleteRstBtn: {
    zIndex: '5',
    left: '30px',
    textTransform: 'capitalize',
  },
  rstSelectedGrayBlock: {
    top: '0',
    left: '0',
    bottom: '0',
    width: '37px',
    background: '#EEECF8',
    position: 'absolute',
  },
  rstSelectedCheckbox: {
    left: '0',
    zIndex: '14',
    display: 'none',
    position: 'absolute',
    '& .MuiIconButton-colorPrimary:hover': {
      background: 'none',
    },
  },
  rstIndex: {
    zIndex: '4',
    color: '#4c4c4c',
    fontSize: '10px',
    width: '25px',
    '&:hover': {
      '& .rst-select-checkbox': {
        display: 'flex',
      },
      '& .rst-index-text': {
        display: 'none',
      },
    },
  },
  rstIndexNewRst: {
    width: '31px',
  },
  rstId: {
    zIndex: '4',
    width: '21px',
    marginRight: '30px',
  },
  rstTypeSelect: {
    width: '160px',
    marginRight: '5px',
  },
  rstSelectControl: {
    width: '100%',
  },
  rstSubject: {
    marginRight: '5px',
  },
  rstSubjectInnerContainer: {
    display: 'flex',
    alignItems: 'center',
    background: '#EEF1F8',
  },
  rstSubjectInput: {
    width: '31px',
    height: '24px',
    flexShrink: '0',
    marginRight: '5px',
    background: '#fff',
  },
  rstSubjectInputText: {
    color: '#878787',
    fontSize: '10px',
    marginRight: '2px',
  },
  zIndex4: {
    zIndex: '4',
  },
  rstTitleInput: {
    background: '#EEECF8',
  },
  rstTitleArrow: {
    color: '#878787',
  },
  rstRTitle: {
    background: '#EEECF8',
  },
  rstObject: {
    width: '300px',
    position: 'relative',
  },
  rstObjectInnerContainer: {
    display: 'flex',
    padding: '15px 5px',
    alignItems: 'center',
    background: '#F6EEF8',
    justifyContent: 'flex-end',
  },
  rstRSubjectInput: {
    width: '31px',
    height: '24px',
    background: '#fff',
  },
  rstData: {
    padding: '5px 5px 5px 1px',
    background: '#F6EEF8',
  },
  rstDataLeftCell: {
    width: '230px',
  },
  secondaryBlock: {
    marginBottom: '2px',
    padding: '10px',
    border: '1px dashed #0000ff29',
  },
  rstDataInput: {
    width: '100%',
    height: '24px',
    background: '#EEECF8',
    '&:hover': {
      background: '#eeecf8',
    },
  },
  rstDataTextarea: {
    zIndex: '4',
    width: '100%',
    border: 'none',
    fontSize: '12px',
    minHeight: '24px',
    maxHeight: '500px',
    padding: '4px 5px',
    resize: 'vertical',
    boxSizing: 'border-box',
    background: '#EEECF8',
    '&:hover': {
      background: '#eeecf8',
    },
  },
  expandArrowLast: {
    position: 'relative',
    bottom: '16px',
  },
  rstBoundsContainer: {
    display: 'inline-flex',
    flexDirection: 'row',
    overflow: 'hidden',
    flexWrap: 'wrap',
    gap: '2px',
  },
  rstBound: {
    color: '#000',
    fontSize: '12px',
    padding: '4px 5px',
    background: '#EEECF8',
    whiteSpace: 'nowrap',
  },
  editIcon: {
    flexShrink: '0',
    fontSize: '16px',
    color: '#878787',
    '&:hover': {
      color: '#4E4C4C',
      cursor: 'pointer',
    },
  },
  rstAdditionalInfoTitle: {
    width: '80px',
    flexShrink: '0',
    marginRight: '5px',
    textAlign: 'right',
    color: '#4C4C4C',
    flexDirection: 'row',
    display: 'inline-flex',
    justifyContent: 'flex-end',
  },
  valueDescription: {
    minWidth: '90px',
    fontSize: '11px',
    color: '#4E4C4C',
    whiteSpace:'nowrap',
  },
  arrowTooltipContainer: {
    marginLeft: '5px',
    width: '20px',
    height: '20px',
  },
  rstAdditionalInfoControl: {
    zIndex: '4',
    width: '100%',
    display: 'flex',
  },
  loader: {
    display: 'inline-flex',
    verticalAlign: 'middle',
    marginLeft: '5px'
  },
  rstAutocompleteTextarea: {
    zIndex: '4',
    border: 'none',
    fontSize: '12px',
    minHeight: '24px',
    padding: '4px 5px',
    resize: 'vertical',
    background: '#EEECF8',
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    verticalAlign: 'top',
    '&:hover': {
      background: '#eeecf8',
    },
  },
  paper: {
    left: 0,
    right: 0,
    zIndex: 999,
    fontSize: 12,
    overflowY: 'hidden',
    background: '#fff',
    position: 'absolute',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)',
  },
  inputField: {
    "&::before": { display: "none" },
    "&::after": { display: "none" },
  },
  functionButton: {
    flexShrink: '0',
    width: '24px',
    height: '22px',
    textTransform: 'none',
    backgroundColor: 'white',
    color: '#C4C4C4',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '16px',
  },
  enabledFunctionButton: {
    backgroundColor: '#E0EFF3',
    color: '#347CFF',
  },
  ...CommonStyles,
};

class Restriction extends Component {
  state = {
    valExpPropProcessing: false,
    valDefPropProcessing: false,
    valExpDialogOpen: false,
    valDefDialogOpen: false,
    titlesDialogOpen: false,
    colorsOfInterface: [],
  };

  componentDidMount() {
    this.getInterfacesCircleColors();
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.rst !== prevProps.rst)
      this.getInterfacesCircleColors();
  };

  getInterfacesCircleColors = () => {
    const { rst, getRstInterfaces, interfacesConceptIds, conceptIndex, rstIndex } = this.props;

    if (interfacesConceptIds && interfacesConceptIds.length) {
      getRstInterfaces(conceptIndex, rstIndex);

      let newColorsOfInterface = [];

      if (rst.implemented_pids && rst.implemented_pids.length) {
        rst.implemented_pids.forEach((interfaceId) => {
          rst.interfaces.forEach((item) => {
            if (item.interfaceRstsIds.includes(interfaceId)) {
              newColorsOfInterface.push(item.node.color);
            }
          });
        });
      }
      if (!isEqual(this.state.colorsOfInterface, newColorsOfInterface ))
        this.setState({ colorsOfInterface: newColorsOfInterface });
    }
  };

  makeTimezonesValsReadyForBackend = (valsArray) => {
    return valsArray.map(item => {
      if (item.hasOwnProperty('default')) {
        return {id: item.id, default: item.default}
      } else {
        return {id: item.id}
      }
    });
  };

  makeTimezonesValsReadyForFront = (valsArray) => {
    const { timezones } = this.props;

    return valsArray.map(item => {
      return {
        ...item,
        gmt: item.id !== '' ? timezones.find(timezone => timezone.id === item.id).gmt : 'empty',
      }
    });
  };

  getDefaultTimezoneVal = (valsArray) => {
    const defaultTimezoneObj = valsArray.find(zone => zone.hasOwnProperty('default'));
    if (defaultTimezoneObj && defaultTimezoneObj.id) return defaultTimezoneObj.id;
    if (defaultTimezoneObj && !defaultTimezoneObj.id) return 'empty';
    return ''
  };

  makeTimezonesReadyForDefaultFront = (selectedTimezones) => {
    const { timezones } = this.props;
    return selectedTimezones.map(item => {
      const fullZoneData = timezones.find(timezone => timezone.id === item.id);
      if (fullZoneData) {
        return {
          title: `(${fullZoneData.gmt}) ${fullZoneData.id}`,
          value: fullZoneData.id,
        }
      } else {
        return {
          title: 'empty',
          value: 'empty',
        }
      }
    });
  };

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.state !== nextState ||
      this.props.rstFieldIndex !== nextProps.rstFieldIndex ||
      this.props.rst !== nextProps.rst ||
      this.props.rst.type !== nextProps.rst.type ||
      JSON.stringify(this.props.timezones) !== JSON.stringify(nextProps.timezones) ||
      this.props.atLeastOneRstOpened !== nextProps.atLeastOneRstOpened ||
      !isEqual(this.props.usedInterfaces, nextProps.usedInterfaces) ||
      !isEqual(this.props.rst.interfaces, nextProps.rst.interfaces)
    );
  };

  setFunctionPerfValues = (type, value) => {
    const { conceptIndex, rstIndex, onMacroFieldChange} = this.props;

    onMacroFieldChange(conceptIndex, rstIndex, type, value);
  };

  addFunctionPerfArguments = (index = -1, argumentName = '', value = '') => {
    const { conceptIndex, rstIndex, addMacroArgument} = this.props;

    addMacroArgument(index, rstIndex, conceptIndex, argumentName, value);
  };

  onArgRemove = (index) => {
    const { conceptIndex, rstIndex, onMacroArgRemove} = this.props;

    onMacroArgRemove(index, rstIndex, conceptIndex);
  };

  render() {
    const {
      rst,
      nodes,
      classes,
      concept,
      rstIndex,
      rstTypes,
      timezones,
      removeRst,
      formatters,
      isAncestor,
      macro_types,
      saveRstCopy,
      conceptIndex,
      returnOldRst,
      removeRstCopy,
      rstFieldIndex,
      enableOverride,
      switchToMacros,
      addNodeToState,
      onRstTypeSelect,
      onRstFieldChange,
      openBoundsModal,
      onSaveRstBtnClick,
      onOverrideRstClick,
      toggleRstAccordeon,
      atLeastOneRstOpened,
      toggleDeleteMsgModal,
      onRstInterfaceSelect,
      toggleConceptRestrictions,
      onTimezoneDefaultFieldChange,
    } = this.props;

    let { colorsOfInterface } = this.state;

    const isOpened = rst && rst.isOpened !== undefined ? rst.isOpened : false;
    const isTimeRst = rst && ['DATE', 'DATE_AND_TIME', 'TIME'].includes(rst.type);
    const isImageRst = rst && ['IMAGE'].includes(rst.type);

    const boundsArr = [];

    if (isOpened && rst.bounds)
      rst.bounds.forEach((bound) => {
        if (bound.item) {
          boundsArr.push(bound.item);
        } else if (bound.node_item) {
          boundsArr.push(bound);
        }
      });

    const disabled = !rst.isEdited;

    return (
      <div className={`${classes.mb5} ${classes.rstBlock}`}>
        <div
          id={rst.id || rstIndex}
          className={`${classes.rstRow} ${classes.spaceBetween}`}
          style={{
            borderLeft: `${rst.overriding || rst.overrided ? '2px solid #DD5900' : ''}`,
            background: `${(rst && !rst.id && rst.isEdited) || (rst && rst.id && rst.isEdited) ? '#DBD6E6' : ''}`,
          }}
        >
          {rst && rst.isSelected ? <div className={classes.rstSelectedGrayBlock} /> : null}

          <div className={`${classes.flex}`}>
            <div className={`${classes.flex}`}>
              {rst && !rst.isEdited ? <div className={classes.rstRowOverlay} /> : null}

              <div
                className={`${rst && rst.id && isAncestor && !rst.inverted ? classes.rstIndex : classes.rstIndexNewRst}`}
                style={{
                  marginTop: `${rst && rst.type === 'OBJECT' ? '19px' : '9px'}`,
                }}
              >
                {rst && rst.id && isAncestor && !rst.inverted ? (
                  <TrplCheckbox
                    disableRipple
                    classes={{
                      root: classes.rstCheckboxGray,
                      label: classes.rstCheckboxLabel,
                    }}
                    checked={rst.isSelected !== undefined ? rst.isSelected : false}
                    className={`rst-select-checkbox ${classes.rstSelectedCheckbox}`}
                    style={{
                      margin: 0,
                      color: '#878787',
                      display: `${rst.isSelected ? 'flex' : ''}`,
                      top: `${rst && rst.type === 'OBJECT' ? '25px' : '14px'}`,
                    }}
                    onChange={(e) => {
                      onRstFieldChange(conceptIndex, rstIndex, 'isSelected', e.target.checked);
                    }}
                  />
                ) : null}

                {!rst.isSelected ? <span className="rst-index-text">{rstFieldIndex}</span> : null}
              </div>

              <div
                className={`${classes.rstId}`}
                style={{
                  marginTop: `${rst && rst.type === 'OBJECT' ? '19px' : '9px'}`,
                }}
              >
                {rst && rst.id && rst.id === 'OVR' ? '' : rst ?
                  <div style={{ fontSize: '11px', width: 'max-content' }}>
                    <span>id: {rst.id}</span>
                  </div>
                : '0'}

                {colorsOfInterface && colorsOfInterface.map((color, itemIndex) => {
                  return (
                    <div
                      key={`${rst.id + itemIndex + color}`}
                      className={`${classes.fillAvailable}`}
                      style={{
                          marginTop: '3px',
                          backgroundColor: `#${color}`,
                          height: '3px',
                        }}
                      title='used in interface'
                    />
                  )
                })}
              </div>
            </div>

            <div
              className={`${classes.rstTypeSelect}`}
              style={{
                zIndex: `${rst && !rst.id && !rst.isEdited ? '4' : ''}`,
              }}
            >
              <TrplSelect
                margin="none"
                values={rstTypes}
                onChange={(e) => onRstTypeSelect(conceptIndex, rstIndex, e.target.value)}
                disabledItemsIndexes={[0]}
                value={rst.type}
                formControlStyles={{
                  marginTop: `${rst && rst.type === 'OBJECT' ? '15px' : '5px'}`,
                }}
                formControlClassName={classes.rstSelectControl}
              />
            </div>

            {rst && rst.type ? (
              <div className={`${classes.rstSubject}`}>
                <div
                  className={classes.rstSubjectInnerContainer}
                  style={{
                    padding: `${rst.type === 'OBJECT' ? '15px 5px' : '5px'}`,
                    background: `${rst.inverted ? '#F6EEF8' : ''}`,
                  }}
                >
                  <span className={classes.rstSubjectInputText}>min</span>

                  <input
                    disabled={!rst.isEdited}
                    className={`${classes.rstSubjectInput} ${classes.rstInput}`}
                    placeholder="Min"
                    value={rst.subjectMinBound}
                    onChange={(e) => onRstFieldChange(conceptIndex, rstIndex, 'subjectMinBound', e.target.value)}
                  />

                  <span className={classes.rstSubjectInputText}>max</span>

                  <input
                    disabled={!rst.isEdited}
                    className={`${classes.rstSubjectInput} ${classes.rstInput}`}
                    placeholder="Max"
                    value={rst.subjectMaxBound}
                    onChange={(e) => {
                      onRstFieldChange(conceptIndex, rstIndex, 'subjectMaxBound', e.target.value);
                    }}
                  />

                  <Node nodeId={rst.sid}
                    isLink
                    size="sm"
                    node={nodes[rst.sid]}
                    nodes={nodes}
                    className={classes.zIndex4}
                  />
                </div>
              </div>
            ) : null}
            
            <div className={`${classes.mr5}`}>
              {rst && rst.type ?
                <div className={`${classes.alignCenter} ${classes.mb5}`}>
                  <input
                    disabled={!rst.isEdited}
                    className={`${classes.rstTitleInput} ${classes.rstInput}`}
                    value={rst.title}
                    placeholder="Title"
                    onChange={(e) => onRstFieldChange(conceptIndex, rstIndex, 'title', e.target.value)}
                  />
                  <KeyboardArrowRightOutlinedIcon className={classes.rstTitleArrow} />
                </div>
              : null}

              {rst.type === 'OBJECT' ? (
                <div className={classes.alignCenter}>
                  <KeyboardArrowLeftOutlinedIcon className={classes.rstTitleArrow} />
                  <input
                    disabled={!rst.isEdited}
                    placeholder="Title"
                    value={rst.r_title}
                    className={`${classes.rstRTitle} ${classes.rstInput}`}
                    onChange={(e) => onRstFieldChange(conceptIndex, rstIndex, 'r_title', e.target.value)}
                  />
                </div>
              ) : null}
            </div>

            <div className={`${classes.rstObject}`}>
              {rst.type === 'OBJECT' ? (
                <Fragment>
                  <div
                    className={classes.rstObjectInnerContainer}
                    style={{
                      background: `${rst.inverted ? '#EEF1F8' : ''}`,
                    }}
                  >
                    <div className={classes.mr5}>
                      {!rst.oid ? (
                        <Search
                          placeholder="Object"
                          inputStyles={{
                            fontSize: 12,
                            color: '#4c4c4c',
                            fontWeight: 'normal',
                            background: '#fff',
                          }}
                          containerStyles={{
                            width: '100%',
                            background: '#fff',
                            height: '24px',
                            alignSelf: 'center',
                          }}
                          onDropdownElementClick={(props) => {
                            const { node } = props;

                            addNodeToState(node);

                            onRstFieldChange(conceptIndex, rstIndex, 'oid', props.node.id);
                          }}
                        />
                      ) : (
                        <Node
                          isLink
                          size="sm"
                          nodeId={rst.oid}
                          node={nodes[rst.oid]}
                          nodes={nodes}
                          isRemovable={rst.isEdited}
                          className={classes.zIndex4}
                          onRemoveClick={() => {
                            onRstFieldChange(conceptIndex, rstIndex, 'oid', '');
                          }}
                        />
                      )}
                    </div>

                    <span className={classes.rstSubjectInputText}>min</span>

                    <input
                      placeholder="Min"
                      disabled={!rst.isEdited}
                      className={`${classes.rstRSubjectInput} ${classes.rstInput} ${classes.mr5}`}
                      value={rst.r_subjectMinBound}
                      onChange={(e) => onRstFieldChange(conceptIndex, rstIndex, 'r_subjectMinBound', e.target.value)}
                    />

                    <span className={classes.rstSubjectInputText}>max</span>

                    <input
                      placeholder="Max"
                      disabled={!rst.isEdited}
                      value={rst.r_subjectMaxBound}
                      className={`${classes.rstRSubjectInput} ${classes.rstInput}`}
                      onChange={(e) => onRstFieldChange(conceptIndex, rstIndex, 'r_subjectMaxBound', e.target.value)}
                    />
                  </div>
                </Fragment>
              ) : null}
            </div>
          </div>

          {!rst || (rst && !rst.id && !rst.type) ? null : (
            <div className={`${classes.flexRow}`} style={{ zIndex: 3 }}>
              <div className={classes.mr10}>
                {(isAncestor || (!isAncestor && rst.overrided)) && rst && !rst.inverted && !rst.isEdited ? (
                  <Edit
                    style={{
                      fontSize: '18px',
                      marginTop: '3px',
                    }}
                    onClick={() => {
                      onRstFieldChange(conceptIndex, rstIndex, 'isOpened', true);
                      onRstFieldChange(conceptIndex, rstIndex, 'isEdited', true);
                      saveRstCopy(concept, rst.id, rst);
                    }}
                  />
                ) : null}
              </div>

              <ArrowTooltipCss text={`${isOpened ? 'Close' : 'Open'}`}>
                {isOpened ? (
                  <KeyboardArrowUpOutlinedIcon onClick={() => toggleRstAccordeon(conceptIndex, rstIndex)} />
                ) : (
                  <KeyboardArrowDownOutlinedIcon onClick={() => toggleRstAccordeon(conceptIndex, rstIndex)} />
                )}
              </ArrowTooltipCss>

              <ArrowTooltipCss text={`${atLeastOneRstOpened ? 'Close all' : 'Open all'}`}>
                {atLeastOneRstOpened ? (
                  <div
                    className={classes.column}
                    onClick={() => toggleConceptRestrictions(conceptIndex, false)}
                  >
                    <KeyboardArrowUpOutlinedIcon/>
                    <KeyboardArrowUpOutlinedIcon className={`${classes.expandArrowLast}`} />
                  </div>
                ) : (
                  <div
                    className={classes.column}
                    onClick={() => toggleConceptRestrictions(conceptIndex, true)}
                  >
                    <KeyboardArrowDownOutlinedIcon className={classes.arrow} />
                    <KeyboardArrowDownOutlinedIcon className={`${classes.expandArrowLast} ${classes.arrow}`} />
                  </div>
                )}
              </ArrowTooltipCss>
            </div>
          )}
        </div>

        {rst && isOpened ? (
          <div
            className={`${classes.rstRow}`}
            style={{
              borderLeft: `${rst.overriding || rst.overrided ? '2px solid #DD5900' : ''}`,
              background: `${(rst && !rst.id && rst.isEdited) || (rst && rst.id && rst.isEdited) ? '#DBD6E6' : ''}`,
            }}
          >
            <div className={`${classes.fillAvailable} ${classes.mr30}`} >
              <div className={classes.ml10}>
                <div className={`${classes.nowrap} ${classes.alignCenter}`}>
                  <TrplCheckbox
                    classes={{
                      root: classes.rstCheckbox,
                      label: classes.rstCheckboxLabel,
                    }}
                    disabled={!rst.isEdited}
                    label="Predicate"
                    checked={rst.isPredicate}
                    onChange={(e) => {
                      onRstFieldChange(conceptIndex, rstIndex, 'isPredicate', e.target.checked);
                    }}
                  />

                  <TrplCheckbox
                    label="Abstract"
                    disabled={!rst.isEdited}
                    checked={rst.isAbstract}
                    classes={{
                      root: classes.rstCheckbox,
                      label: classes.rstCheckboxLabel,
                    }}
                    onChange={(e) => {
                      onRstFieldChange(conceptIndex, rstIndex, 'isAbstract', e.target.checked);
                    }}
                  />

                  {enableOverride ? (
                    <button
                      className={`${classes.overrideBtn} ${classes.mb10}`}
                      onClick={() => {
                        onOverrideRstClick(conceptIndex, rst, rstIndex);
                      }}
                    >
                      Override
                    </button>
                  ) : null}

                  <div style={{ pointerEvents: rst.isEdited ? '' : 'none' }} className={classes.alignCenter}>
                    <ArrowTooltipCss text={`${rst.macro ? "Remove macro" : 'Switch to macro'}`}>
                      <Switcher
                        switched={rst.macro}
                        onChange={() => {
                          rst.macro && Object.keys(rst.macro).length ?
                          toggleDeleteMsgModal(conceptIndex, rstIndex, rst.id, rst.title, true, "Remove Macros from restriction")
                            : rst.macro ? switchToMacros(conceptIndex, rstIndex, false)
                            : switchToMacros(conceptIndex, rstIndex, true);
                        }
                        }
                      />
                    </ArrowTooltipCss>
                    <strong style={{ color: '#4C4C4C' }} className={classes.ml5}> macro </strong>
                  </div>
                </div>
              </div>

              <div className={`${classes.p10} ${classes.mb10}`}>
                <div className={`${classes.nowrap} ${classes.mt10} ${classes.alignCenter}`}>
                  <span className={`${classes.valueDescription} ${classes.mr5}`}>Variable name</span>

                  <div className={classes.rstAdditionalInfoControl}>
                    <input
                      style={{
                        background: '#EEECF8',
                      }}
                      value={rst.var_name || ''}
                      disabled={!rst.isEdited}
                      className={`${classes.rstDataInput} ${classes.rstInput}`}
                      onChange={(e) => onRstFieldChange(conceptIndex, rstIndex, 'var_name', e.target.value)}
                    />
                  </div>
                </div>

                {rst.interfaces && rst.interfaces.length ? (
                  <div className={`${classes.mt10} ${classes.alignCenter}`}>
                    <span className={`${classes.valueDescription} ${classes.nowrap} ${classes.mr5}`}>
                      Interface impl.
                    </span>

                    <div className={classes.fillAvailable}>
                      {rst.interfaces.map(item => {
                        let interfaceRstsValues = item.interfaceRstsValues;
                        let interfaceRstsIds = item.interfaceRstsIds;

                        let selectValue = 'none';
                        if (rst.implemented_pids && rst.implemented_pids.length) {
                          rst.implemented_pids.forEach((interfaceId) => {
                            if (item.interfaceRstsIds.includes(interfaceId)) {
                              const index = interfaceRstsIds.indexOf(interfaceId);
                              if (index !== -1) {
                                selectValue = interfaceRstsValues[index].value ? item.interfaceRstsValues[index].value : 'none';
                              }
                            }
                          });
                        }

                        return (
                          <div
                            key={item.node.id}
                            style={{ gap: '2px', marginBottom: '2px' }}
                            className={`${classes.alignCenter} ${classes.fillAvailable}`}
                          >
                            <Node nodeId={item.id} isLink size="sm" node={item.node} nodes={nodes} />
                            <TrplSelect
                              placeholder='Select interface'
                              margin="none"
                              disabled={!rst.isEdited}
                              values={item.interfaceRstsValues || ''}
                              complicatedValues
                              onChange={(e) => onRstInterfaceSelect(item, e.target.value, conceptIndex, rstIndex)}
                              value={selectValue || 'none'}
                              formControlClassName={classes.rstSelectControl}
                            />
                          </div>
                        )
                      })}
                    </div>
                  </div>
                ) : null}

                <div className={`${classes.alignCenter} ${classes.mt10} ${classes.fillAvailable}`}>
                  <span className={`${classes.valueDescription} ${classes.mr5} ${classes.mb5}`}>
                    Description
                  </span>
                  <div className={`${classes.column} ${classes.ml5} ${classes.fillAvailable}`}>
                    {["en","ru"].map((elem) => {//TODO langs should be received from the backend
                      return (
                        <div key={elem} className={`${classes.alignCenter} ${classes.mb5} ${classes.fillAvailable}`}>
                          <div style={{ fontSize: 11, zIndex: 5, width: '20px' }}>
                            <span className={`${classes.mr5}`}>{`${elem}:`}</span>
                          </div>
                          <textarea
                            rows={1}
                            disabled={!rst.isEdited}
                            className={`${classes.rstDataTextarea} ${classes.fillAvailable}`}
                            style={{ marginLeft: '-25px', paddingLeft: '25px', width: 'inherit' }}
                            value={rst.description ? rst.description[elem] : ""}
                            onChange={(e) => {
                              if (!rst.description) rst.description = {};
                              const description = {...rst.description};
                              description[elem] = e.target.value;
                              onRstFieldChange(conceptIndex, rstIndex, "description", description)
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              {isImageRst ? (
                <div className={`${classes.secondaryBlock}`}>
                  <TrplCheckbox
                    label="Avatar"
                    disabled={!rst.isEdited}
                    checked={rst.isAvatar}
                    classes={{
                      root: classes.rstCheckbox,
                      label: classes.rstCheckboxLabel,
                    }}
                    onChange={(e) => {
                      onRstFieldChange(conceptIndex, rstIndex, 'isAvatar', e.target.checked);
                    }}
                  />
                </div>
              ) : null}

              {rst.primitive === '_obj' ? (
                <div className={`${classes.secondaryBlock}`}>
                  <TrplCheckbox
                    label="Singleton"
                    disabled={!rst.isEdited}
                    checked={rst.isSingleton}
                    classes={{
                      root: classes.rstCheckbox,
                      label: classes.rstCheckboxLabel,
                    }}
                    onChange={(e) => {
                      onRstFieldChange(conceptIndex, rstIndex, 'isSingleton', e.target.checked);
                    }}
                  />
                </div>
              ) : null}

              {isTimeRst ?
                <div className={`${classes.secondaryBlock}`}>
                  <TrplCheckbox
                    label="Locale correction"
                    disabled={!rst.isEdited}
                    checked={rst.locale_correction}
                    classes={{
                      root: classes.rstCheckbox,
                      label: classes.rstCheckboxLabel,
                    }}
                    onChange={(e) => {
                      onRstFieldChange(conceptIndex, rstIndex, 'locale_correction', e.target.checked);
                    }}
                  />
                  <div className={`${classes.nowrap} ${classes.mt10} ${classes.alignCenter}`}>
                    <span className={`${classes.valueDescription} ${classes.mr5}`}>
                      Use format
                    </span>

                    <input
                      style={{
                        background: '#EEECF8',
                      }}
                      placeholder="Date\Time format"
                      value={rst.datetime_format}
                      disabled={!rst.isEdited}
                      className={`${classes.rstDataInput} ${classes.rstInput}`}
                      onChange={(e) => onRstFieldChange(conceptIndex, rstIndex, 'datetime_format', e.target.value)}
                    />
                  </div>

                  {timezones && timezones.length ?
                    <React.Fragment>
                      <div className={`${classes.nowrap} ${classes.mt10} ${classes.alignCenter}`}>
                        <span className={`${classes.valueDescription} ${classes.mr5}`}>
                          Timezones
                        </span>

                        <Autocomplete
                          multiple
                          size="small"
                          id="timezones"
                          disableCloseOnSelect
                          disabled={!rst.isEdited}
                          classes={{ paper: `${classes.paper}` }}
                          sx={{ width: '-webkit-fill-available' }}
                          options={[ {gmt: 'empty', id: ''}, ...timezones ]}
                          getOptionLabel={(option) => `(${option.gmt}) ${option.id}`}
                          isOptionEqualToValue={(option, value) => option.id === value.id }
                          value={rst.timezones && rst.timezones.length
                            ? this.makeTimezonesValsReadyForFront(rst.timezones) : []}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              InputProps={{
                                ...params.InputProps,
                                className: `${classes.inputField} ${classes.rstAutocompleteTextarea}`,
                              }}
                            />
                          )}
                          onChange={(e, newValue) => {
                            if (newValue && newValue.length) {
                              onRstFieldChange(conceptIndex, rstIndex, 'timezones', this.makeTimezonesValsReadyForBackend(newValue));
                            } else {
                              onRstFieldChange(conceptIndex, rstIndex, 'timezones', []);
                            }
                          }}
                        />
                      </div>

                      <div className={`${classes.nowrap} ${classes.mt10} ${classes.alignCenter}`}>
                        <span className={`${classes.valueDescription} ${classes.mr5}`}>
                          Default timezone
                        </span>

                        <TrplSelect
                          margin="none"
                          addEmptyItem
                          complicatedValues
                          disabled={!rst.isEdited || !rst.timezones || !rst.timezones.length}
                          values={rst.timezones && rst.timezones.length ? this.makeTimezonesReadyForDefaultFront(rst.timezones) : []}
                          onChange={(e) => {
                            onTimezoneDefaultFieldChange(conceptIndex, rstIndex, e.target.value);
                          }}
                          value={(rst.timezones && rst.timezones.length && this.getDefaultTimezoneVal(rst.timezones)) || ''}
                          formControlClassName={classes.rstSelectControl}
                        />
                      </div>
                    </React.Fragment>
                  : null}
                </div>
              : null}

              {rst && rst.used_in_macros ?
                <div className={`${classes.fillAvailable} ${classes.rstBoundsContainer} ${classes.secondaryBlock}`}>
                  <span style={{ marginTop: '4px' }} className={`${classes.valueDescription} ${classes.mr5}`}>
                    Macro used in
                  </span>
                  {rst.used_in_macros.map((id, index) => {
                    return (
                      <a
                        key={index}
                        target="_blank"
                        rel="noreferrer"
                        href={`/events?pids=[${rst.id}]`}
                        style={{ display: 'flex', color: 'unset' }}
                      >
                        <span className={classes.rstBound}>{id}</span>
                      </a>
                    )
                  })}
                </div>
              : null}

              {rst && rst.hasOwnProperty('used_in_views') ?
                <div className={`${classes.secondaryBlock}`}>
                  {Object.keys(rst.used_in_views).map((viewType, viewIndex) => {
                    return (
                      <div
                        key={viewIndex}
                        className={`${classes.rstBoundsContainer} ${classes.fillAvailable} ${classes.mb5}`}
                      >
                        <span
                          style={{ marginTop: '4px' }}
                          className={`${classes.valueDescription} ${classes.mr5}`}
                        >
                          {viewType} used in
                        </span>

                        {rst.used_in_views[viewType].map((id, index) => {
                          return (
                            <a
                              key={index}
                              target="_blank"
                              rel="noreferrer"
                              href={`/ui_edit?tab=${viewType === 'trpls_tbl' ? 'table' :'form'}&id=${id}`}
                              style={{ display: 'flex', color: 'unset' }}
                            >
                              <span key={index} className={classes.rstBound}>{id}</span>
                            </a>
                          )
                        })}
                      </div>
                    )
                  })}
                </div>
              : null}
            </div>
            {/* end of first block */}
            
            <div style={{ minWidth: '640px' }}>
              {rst.macro ?
                <div className={classes.mt40}>
                  {rst.type === 'BUTTON' ? (
                    <div className={`${classes.mb10} ${classes.alignCenter} ${classes.secondaryBlock}`}>
                      <div className={classes.rstAdditionalInfoTitle}>
                        <span className={classes.valueDescription}>Button title</span>
                      </div>

                      <div className={classes.rstAdditionalInfoControl}>
                        <input
                          value={rst.btn_title}
                          disabled={!rst.isEdited}
                          className={`${classes.rstDataInput} ${classes.rstInput}`}
                          onChange={(e) => onRstFieldChange(conceptIndex, rstIndex, 'btn_title', e.target.value)}
                        />
                      </div>
                    </div>
                  ) : null}

                  <Macros
                    nodes={nodes}
                    showArgs={true}
                    showCode={true}
                    macro={rst.macro}
                    showAsync={rst.type === 'BUTTON'}
                    showScriptType={true}
                    showReturnType={true}
                    editable={rst.isEdited}
                    macro_types={macro_types}
                    onArgRemove={this.onArgRemove}
                    addNodeToState={addNodeToState}
                    functionVal={rst.macro.code || ''}
                    scriptType={rst.macro.script_type || ''}
                    returnType={rst.macro.return_type || ''}
                    funcArguments={rst.macro.args || []}
                    setFunctionPerfValues={this.setFunctionPerfValues}
                    addFunctionPerfArguments={this.addFunctionPerfArguments}
                  />
                </div>
              :
              <React.Fragment>
                <div className={`${classes.nowrap} ${classes.flex}`} style={{ marginLeft: '100px' }}>
                  <TrplCheckbox
                    label="ISA"
                    checked={rst.isa}
                    disabled={!rst.isEdited}
                    classes={{
                      root: classes.rstCheckbox,
                      label: classes.rstCheckboxLabel,
                    }}
                    onChange={(e) => {
                      onRstFieldChange(conceptIndex, rstIndex, 'isa', e.target.checked);
                    }}
                  />

                  {rst.type !== 'OBJECT' ? (
                    <TrplCheckbox
                      label="Title"
                      checked={rst.isTitle}
                      disabled={!rst.isEdited}
                      classes={{
                        root: classes.rstCheckbox,
                        label: classes.rstCheckboxLabel,
                      }}
                      onChange={(e) => {
                        onRstFieldChange(conceptIndex, rstIndex, 'isTitle', e.target.checked);
                      }}
                    />
                  ) : null}

                  <TrplCheckbox
                    label="Constant"
                    disabled={!rst.isEdited}
                    checked={rst.isConstant}
                    classes={{
                      root: classes.rstCheckbox,
                      label: classes.rstCheckboxLabel,
                    }}
                    onChange={(e) => {
                      onRstFieldChange(conceptIndex, rstIndex, 'isConstant', e.target.checked);
                    }}
                  />
                </div>

                <div className={classes.mt20}>
                  <div className={`${classes.mb10} ${classes.alignCenter}`}>
                    <div className={classes.rstAdditionalInfoTitle}>
                      <span className={classes.valueDescription}>Default</span>
                      <div className={classes.arrowTooltipContainer}>
                        <ArrowTooltipCss text="Apply default">
                          {this.state.valDefPropProcessing
                            ? (
                              <LoaderNew color='grey' className={classes.loader} />
                            ) : (
                              <button
                                style={{ padding: '0px', pointerEvents: rst.isEdited ? '' : 'none' }}
                                onClick={() => {
                                  this.setState({ valDefDialogOpen: true});
                                }}
                                size="large">
                                <AutorenewOutlined fontSize='small' />
                              </button>
                            )
                          }
                        </ArrowTooltipCss>
                      </div>
                      <ValueApplyDialog
                        name='Applying default to predicates'
                        valDialogOpen={this.state.valDefDialogOpen}
                        valDefPropProcessing={this.state.valDefPropProcessing}
                        valDefSetProcessing={(value, cb) => this.setState({ valDefPropProcessing: value, valDefDialogOpen: false }, cb)}
                        onClose={() => this.setState({ valDefDialogOpen: false })}
                        rst={rst}
                      />
                    </div>

                    <div>
                      <RadioGroup
                        value={rst.default_method}
                      >
                        <FormControlLabel
                          style={{ height: '32px', margin: 0 }}
                          value={0}
                          control={
                            <Radio
                              disabled={disabled}
                              color="default"
                              onChange={(e) => onRstFieldChange(conceptIndex, rstIndex, 'default_method', +e.target.value)}
                            />
                          }
                        />
                        {rst.type === 'INTEGER' ?
                          <FormControlLabel
                            style={{ height: '32px', margin: 0 }}
                            value={1}
                            control={
                              <Radio
                                disabled={disabled}
                                color="default"
                                onChange={(e) => onRstFieldChange(conceptIndex, rstIndex, 'default_method', +e.target.value)}
                              />
                            }
                          />
                        : null}
                        <FormControlLabel
                          style={{ height: '32px', margin: 0 }}
                          value={2}
                          control={
                            <Radio
                              disabled={disabled}
                              color="default"
                              onChange={(e) => onRstFieldChange(conceptIndex, rstIndex, 'default_method', +e.target.value)}
                            />
                          }
                        />
                        <FormControlLabel
                          //className={classes.frmControlLabel}
                          style={{ height: '32px', margin: 0 }}
                          value={3}
                          control={
                            <Radio
                              disabled={disabled}
                              color="default"
                              onChange={(e) => onRstFieldChange(conceptIndex, rstIndex, 'default_method', +e.target.value)}
                            />
                          }
                        />
                      </RadioGroup>
                    </div>


                    <div className={classes.fillAvailable}>
                      <div className={`${classes.alignCenter} ${classes.mb10}`}>
                        <span className={classes.valueDescription}>Disabled</span>
                        <div style={{ height: '21px' }}></div>
                      </div>

                      {rst.type === 'INTEGER' ?
                        <div className={`${classes.alignCenter} ${classes.mb10}`}>
                          <span className={classes.valueDescription}>Next value</span>
                          <input
                            type={'number'}
                            value={rst.next_autoincrement_value}
                            disabled={!rst.isEdited}
                            className={`${classes.rstDataInput} ${classes.rstInput}`}
                            onChange={(e) => onRstFieldChange(conceptIndex, rstIndex, 'next_autoincrement_value', e.target.value)}
                          />

                          <span className={`${classes.ml10} ${classes.mr10}`} style={{ fontSize: 11, color: '#4c4c4c' }}>Global</span>
                          <TrplCheckbox
                            disabled={disabled}
                            checked={rst.is_autoincrement_global}
                            classes={{
                              root: classes.rstCheckbox,
                              label: classes.rstCheckboxLabel,
                            }}
                            onChange={(e) => {
                              onRstFieldChange(conceptIndex, rstIndex, 'is_autoincrement_global', e.target.checked);
                            }}
                          />
                        </div>
                      : null}

                      <div className={`${classes.alignCenter} ${classes.mb10}`}>
                        <span className={classes.valueDescription}>Value</span>
                        <input
                          value={rst.default_value}
                          disabled={!rst.isEdited}
                          className={`${classes.rstDataInput} ${classes.rstInput}`}
                          onChange={(e) => onRstFieldChange(conceptIndex, rstIndex, 'default_value', e.target.value)}
                        />
                      </div>

                      <div className={`${classes.alignCenter}`}>
                        <span className={classes.valueDescription}>Function</span>
                        <input
                          value={rst.default_func}
                          disabled={!rst.isEdited}
                          className={`${classes.rstDataInput} ${classes.rstInput}`}
                          onChange={(e) => onRstFieldChange(conceptIndex, rstIndex, 'default_func', e.target.value)}
                        />
                      </div>

                    </div>
                  </div>

                  <div className={`${classes.mb10} ${classes.alignCenter}`}>
                    <div className={classes.rstAdditionalInfoTitle}>
                      <span className={classes.valueDescription} style={{marginRight: '5px'}}>Delete after</span>
                    </div>
                    <div className={classes.rstAdditionalInfoControl}>
                      <input
                        type={'number'}
                        value={rst.del_after}
                        disabled={!rst.isEdited}
                        placeholder="minutes"
                        className={`${classes.rstDataInput} ${classes.rstInput}`}
                        onChange={(e) => onRstFieldChange(conceptIndex, rstIndex, 'del_after', e.target.value)}
                      />
                    </div>
                  </div>

                  <div className={`${classes.mb10} ${classes.alignCenter}`}>
                    <div className={classes.rstAdditionalInfoTitle}>
                      <span className={classes.valueDescription}>Expression</span>
                      <div className={classes.arrowTooltipContainer}>
                        <ArrowTooltipCss text="Apply expression">
                          {this.state.valExpPropProcessing
                            ? (
                              <LoaderNew color='grey' className={classes.loader} />
                            ) : (
                              <button
                                style={{ padding: '0px', pointerEvents: rst.isEdited ? '' : 'none' }}
                                onClick={() => {
                                  this.setState({ valExpDialogOpen: true });
                                }}
                                size="large">
                                <AutorenewOutlined fontSize='small' />
                              </button>
                            )
                          }
                        </ArrowTooltipCss>
                      </div>
                      <ValueApplyDialog
                        name='Applying expression to predicates'
                        valDialogOpen={this.state.valExpDialogOpen}
                        valExpPropProcessing={this.state.valExpPropProcessing}
                        valExpSetProcessing={(value, cb) => this.setState({ valExpPropProcessing: value, valExpDialogOpen: false }, cb)}
                        onClose={() => this.setState({ valExpDialogOpen: false })}
                        rst={rst}
                      />
                    </div>

                    <div className={classes.rstAdditionalInfoControl}>
                      <textarea
                        rows={1}
                        value={rst.value_expression}
                        className={classes.rstDataTextarea}
                        onChange={(e) => {
                          if (rst.isEdited)
                            onRstFieldChange(conceptIndex, rstIndex, 'value_expression', e.target.value);
                        }}
                      />
                    </div>
                  </div>

                  {!TYPES_WITHOUT_BOUNDS.includes(rst.type) && (
                    <div className={`${classes.mb10} ${classes.alignCenter}`}>
                      <div className={classes.rstAdditionalInfoTitle}>
                        <span className={classes.valueDescription} style={{marginRight: '5px'}}>Bounds</span>
                      </div>

                      <div className={classes.rstAdditionalInfoControl}>
                        <div className={classes.fillAvailable}>
                          <div
                            className={`${classes.alignCenter} ${
                              boundsArr.length || rst.isEdited ? classes.mb5 : ''
                            }`}
                          >
                            {boundsArr.length && (rst.primitive === '_obj' || rst.type === 'OBJECT') ? (
                              <div className={classes.rstBoundsContainer}>
                                {boundsArr.map((bound, boundIndex) => {
                                  return (
                                    <Node
                                      isLink
                                      size="xs"
                                      key={boundIndex}
                                      nodeId={bound.node_item}
                                      node={nodes[bound.node_item]}
                                      nodes={nodes}
                                      style={{ marginRight: '5px' }}
                                    />
                                  );
                                })}
                              </div>
                            ) : boundsArr.length ? (
                              <div className={classes.rstBoundsContainer}>
                                {boundsArr.map((bound, boundIndex) => {
                                  if (bound) {
                                    return (
                                      <div key={boundIndex} className={classes.rstBound}>
                                        {bound}
                                      </div>
                                    );
                                  } else {
                                    return null;
                                  }
                                })}
                              </div>
                            ) : null}

                            <div style={{marginLeft: '5px'}}>
                              {rst.isEdited ? (
                                <ArrowTooltipCss text="Edit">
                                  <Edit
                                    className={classes.editIcon}
                                    onClick={() => openBoundsModal(rst, conceptIndex, rstIndex)}
                                  />
                                </ArrowTooltipCss>
                              ) : null}
                            </div>
                          </div>

                          <div className={`${classes.mt5} ${classes.flex} ${classes.mb5}`}>
                            <TrplCheckbox
                              label="strict"
                              disabled={!rst.isEdited}
                              checked={rst.is_bounds_strict || !rst.hasOwnProperty('is_bounds_strict')}
                              classes={{
                                root: classes.rstCheckbox,
                                label: classes.rstCheckboxLabel,
                              }}
                              onChange={(e) => {
                                onRstFieldChange(conceptIndex, rstIndex, 'is_bounds_strict', e.target.checked);
                              }}
                            />
                          </div>

                          <input
                            value={rst.boundaries}
                            disabled={!rst.isEdited}
                            className={`${classes.rstDataInput} ${classes.rstInput}`}
                            onChange={(e) => onRstFieldChange(conceptIndex, rstIndex, 'boundaries', e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  <div className={`${classes.mb10} ${classes.alignCenter}`}>
                    <div className={classes.rstAdditionalInfoTitle}>
                      <span className={classes.valueDescription}>Function</span>
                    </div>

                    <div className={classes.rstAdditionalInfoControl}>
                      <textarea
                        value={rst.func}
                        onChange={(e) => {
                          if (rst.isEdited) {
                            onRstFieldChange(conceptIndex, rstIndex, 'func', e.target.value);
                          }
                        }}
                        rows={1}
                        className={classes.rstDataTextarea}
                      />
                    </div>
                  </div>

                  <div className={`${classes.alignCenter} ${classes.mb10}`}>
                    <div className={classes.rstAdditionalInfoTitle}>
                      <span className={classes.valueDescription}>Regex</span>
                    </div>

                    <div className={classes.rstAdditionalInfoControl}>
                      <input
                        value={rst.regex}
                        disabled={!rst.isEdited}
                        className={`${classes.rstDataInput} ${classes.rstInput}`}
                        onChange={(e) => {
                          onRstFieldChange(conceptIndex, rstIndex, 'regex', e.target.value);
                        }}
                      />
                    </div>
                  </div>

                  {formatters && (
                    <div className={`${classes.alignCenter}`}>
                      <div className={classes.rstAdditionalInfoTitle}>
                        <span className={classes.valueDescription}>Formatters</span>
                      </div>

                      <div
                        className={classes.rstAdditionalInfoControl}
                      >
                        <TrplSelect
                          multiple
                          margin="none"
                          complicatedValues
                          disabled={!rst.isEdited}
                          value={rst.formatters || []}
                          values={formatters}
                          onChange={(e) => {
                            if (rst.isEdited) {
                              onRstFieldChange(conceptIndex, rstIndex, 'formatters', e.target.value);
                            }
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>

                <div className={`${classes.mt10} ${classes.mb10} ${classes.alignCenter}`}>
                  <div className={classes.rstAdditionalInfoTitle}>
                    <span className={classes.valueDescription}>Structure</span>
                  </div>

                  <div className={classes.rstAdditionalInfoControl}>
                    <input
                      value={rst.render}
                      disabled={!rst.isEdited}
                      className={`${classes.rstDataInput} ${classes.rstInput}`}
                      onChange={(e) => {
                        onRstFieldChange(conceptIndex, rstIndex, 'render', e.target.value);
                      }}
                    />
                  </div>
                </div>

                <div className={`${classes.mb10} ${classes.mb10} ${classes.alignCenter}`}>
                  <div className={classes.rstAdditionalInfoTitle}>
                    <span className={classes.valueDescription}>Json</span>
                  </div>

                  <div className={classes.rstAdditionalInfoControl}>
                    <textarea
                      rows={1}
                      value={rst.data}
                      onChange={(e) => {
                        if (rst.isEdited) {
                          onRstFieldChange(conceptIndex, rstIndex, 'data', e.target.value);
                        }
                      }}
                      className={classes.rstDataTextarea}
                    />
                  </div>
                </div>

                <div className={`${classes.mb10} ${classes.alignCenter}`}>
                  <div className={classes.rstAdditionalInfoTitle}>
                    <span className={classes.valueDescription}>Unique sid</span>
                  </div>

                  <div className={classes.rstAdditionalInfoControl}>
                    <div className={classes.mr5}>
                      {!rst.unique_sid ? (
                        <Search
                          disableTrplEditing={!rst.isEdited}
                          inputStyles={{
                            fontSize: 12,
                            color: '#4c4c4c',
                            fontWeight: 'normal',
                          }}
                          containerStyles={{
                            width: '100%',
                            height: '24px',
                            alignSelf: 'center',
                          }}
                          onDropdownElementClick={(props) => {
                            const { node } = props;

                            addNodeToState(node);

                            onRstFieldChange(conceptIndex, rstIndex, 'unique_sid', props.node.id);
                          }}
                        />
                      ) : (
                        <Node
                          isLink
                          size="sm"
                          nodeId={rst.unique_sid}
                          node={nodes[rst.unique_sid]}
                          nodes={nodes}
                          isRemovable={rst.isEdited}
                          className={classes.zIndex4}
                          onRemoveClick={() => {
                            onRstFieldChange(conceptIndex, rstIndex, 'unique_sid', null);
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </React.Fragment>
              }
            </div>
          </div>
        ) : null}

        {rst && rst.isEdited && isOpened ? (
          <div className={`${classes.spaceBetween} ${classes.p10}`} style={{ backgroundColor: '#DBD6E6' }}>
            <ButtonBase
              size="small"
              className={`${classes.btn} ${classes.btnEmpty} ${classes.deleteRstBtn}`}
              onClick={() => {
                toggleDeleteMsgModal(conceptIndex, rstIndex, rst.id, rst.title, true, "Delete Restriction");
              }}
              style={{
                textTransform: 'capitalize',
              }}
            >
              Delete
            </ButtonBase>
            <div className={`${classes.rstSaveEdit} ${classes.alignCenter}`}>
              <ButtonBase
                size="small"
                className={`${classes.btn} ${classes.btnEmpty} ${classes.mr20}`}
                style={{
                  textTransform: 'capitalize',
                }}
                onClick={() => {
                  if (rst.id === 'OVR') {
                    removeRst(conceptIndex, rstIndex);
                  } else {
                    onRstFieldChange(conceptIndex, rstIndex, 'isEdited', false);

                    returnOldRst(concept, rst.id);

                    if (rst.id) removeRstCopy(concept, rst.id);

                    if (!rst.id) {
                      onRstFieldChange(conceptIndex, rstIndex, 'isOpened', false);
                    }
                  }
                }}
              >
                Cancel
              </ButtonBase>

              <ButtonBase
                size="small"
                className={`${classes.btn} ${classes.btnNormal}`}
                style={{
                  textTransform: 'capitalize',
                }}
                onClick={() => {
                  onSaveRstBtnClick(conceptIndex, rstIndex);
                }}
              >
                {rst.isLoading ? <LoaderNew /> : 'Save'}
              </ButtonBase>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
};

export default withStyles(styles)(Restriction);
